module.exports = __webpack_public_path__ + "static/media/Duplicate_Icon.ddc57953.svg";